import React, { useState } from 'react';
import useMobile from 'utils/useMobile';

import HeroContainerMobile from 'components/HeroContainer/mobile';
import { Typography } from '@material-ui/core';
import HeroContainer from 'components/HeroContainer/desktop';
import HeaderButton from 'views/Landing/HeaderButton';
import VideoPlayer from 'components/VideoPlayer';

const HeroContentMembers = () => {
  const isMobile = useMobile();
  const Container = isMobile ? HeroContainerMobile : HeroContainer;
  const headerSize = isMobile ? 'h4' : 'h2';

  const [openVideo, setOpenVideo] = useState(false);
  return (
    <Container>
      {!isMobile && (
        <Typography variant="h6" gutterBottom>
          LET'S GET STARTED!
        </Typography>
      )}
      <Typography variant={headerSize}>IT'S TIME TO PUT</Typography>
      <Typography variant={headerSize}>YOUR BODYF1RST!</Typography>

      <HeaderButton size="large" onClick={() => setOpenVideo(true)}>
        watch video
      </HeaderButton>
      <VideoPlayer
        open={openVideo}
        onClose={() => setOpenVideo(false)}
        height={560}
        url={process.env.REACT_APP_PLACEHOLDER_VIDEO}
      />
    </Container>
  );
};

export default HeroContentMembers;
